import { connect } from 'react-redux'
import React, { Component } from 'react'
import _ from 'lodash'
import { Router, Switch, Route, Redirect } from 'react-router-dom'
import { SignInScreen, SignUpScreen, DefaultLayout } from '../layouts'
import history from './history'
import Header from '../containers/Header'
import AppRoutes from './AppRoutes'
import { getToken } from '../utils/helper'
import ForgotPassword from '../layouts/ForgotPassword'
import ResetPassword from '../layouts/ResetPassword'
import { setLocalStorage } from '../utils/localStorage'
import Footer from '../containers/Footer'
import { Box } from '@material-ui/core'

const RestrictedRoute = ({ component: Component, authUser, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      authUser ? (
        <>
          <Header isSignedInUser />
          <Box flexGrow="1" minHeight='calc(100vh - 114px)'>
            <Component {...props} />
          </Box>
          <Footer />
        </>
      ) : (
        <Redirect
          to={{ pathname: '/signin', state: { from: props.location } }}
        />
      )
    }
  />
)

class Routes extends Component {
  state = {
    auth: getToken(),
  }

  render() {
    const { authUser, location, match } = this.props
    if (location.pathname === '/') {
      if (authUser === null || _.isEmpty(authUser)) {
        return <Redirect to="/signin" from={location.pathname} />
      } else {
        return <Redirect to="/dashboard" />
      }
    }
    return (
      <Router history={history}>
        <Switch>
          <DefaultLayout exact path="/" component={SignInScreen} />
          <DefaultLayout exact path="/signin" component={SignInScreen} />
          <DefaultLayout exact path="/signup" component={SignUpScreen} />
          <DefaultLayout
            exact
            path="/forgot-password"
            component={ForgotPassword}
          />
          <DefaultLayout
            path="/admin/passwordConfirm"
            component={ResetPassword}
          />
          <RestrictedRoute
            path={`${match.url}`}
            authUser={authUser}
            component={AppRoutes}
          />
          <Redirect to="/signin" />
        </Switch>
      </Router>
    )
  }
}

const mapStateToProps = ({ auth }) => {
  const { authUser } = auth
  return { authUser }
}

export default connect(mapStateToProps, {})(Routes)
